"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScaleChecked = exports.useScale = exports.ScaleProvider = exports.scaleContext = void 0;
const react_1 = require("react");
const scaleReducer_1 = require("../reducer/scaleReducer");
exports.scaleContext = (0, react_1.createContext)(scaleReducer_1.scaleInitialState);
exports.ScaleProvider = exports.scaleContext.Provider;
function useScale() {
    return (0, react_1.useContext)(exports.scaleContext);
}
exports.useScale = useScale;
function useScaleChecked() {
    const scale = useScale();
    if (!scale.scaleX || !scale.scaleY) {
        throw new Error('scale cannot be null');
    }
    return scale;
}
exports.useScaleChecked = useScaleChecked;
